import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-sensor-selector',
    templateUrl: './sensor-selector.component.html',
    styleUrls: ['./sensor-selector.component.scss'],
    standalone: false
})
export class SensorSelectorComponent implements OnInit, ControlValueAccessor, OnChanges {

  public sensorChipId: string | null = null;
  @Output()
  public sensorIdChange = new EventEmitter<string | null>();

  public InitChipId = "";
  @Input()
  public Sensor: any = {};

  public searchResults: any[] = [];
  public searchTerm: string = "ChipId";
  public isLoading = false;

  constructor(private apiService: ApiServiceBase, @Self() public ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.sensorChipId = this.Sensor.ChipId;
    this.onChange(this.Sensor.ChipId);
    this.sensorIdChange.emit(this.Sensor);
  }

  public writeValue(id: string | null): void {
    console.log("Write value");

    this.sensorChipId = id;
    this.Sensor.ChipId = id;
    if (this.sensorChipId == "") this.Sensor = null;
  }
  public onChange = (id: string | null) => {
    this.sensorIdChange.emit(id);
   };
   
  public registerOnChange(fn: any): void {
    console.log("Reg on change");

    this.onChange = fn;
  }
  public onTouched = () => { };
  public registerOnTouched(fn: any): void {
    console.log("On Touched");

    this.onTouched = fn;
  }
  ngOnInit(): void {
  }


  public ItemSelected(item: any) {
    if (item && item != null && item.Id) {
      this.Sensor = { Id: item.Id, ChipId: item.ChipId, OrganizationId: item.OrganizationId };
      this.sensorChipId = item.ChipId;
      this.onChange(item.ChipId);
      this.sensorIdChange.emit(this.Sensor);
    }
  }
  public SearchChanged(val: string) {
    console.log("Sensor Selector search event: '" + val + "'");
    if (val == null || val == "") return;
    this.Sensor = null;
    this.isLoading = true;
    //"infrastructure/sensor/searches"
    this.apiService.Post<any>("infrastructure/sensor/searches", { PageNumber: 1, PageSize: 8, SearchTerm: val }).then(result => {
      this.searchResults = [];
      result.Results.forEach((element: any) => {
        this.searchResults.push({
          ChipId: element.ChipId.toString(),
          Id: element.Id,
          OrganizationId: element.OrganizationId
        });
      });

      console.log("Search results: ");

      console.log(this.searchResults);

      this.isLoading = false;
    });
  }
  public ClearSensor() {
    this.sensorChipId = null;
    this.onChange(null);
  }

  public Cleared() {
    this.sensorChipId = null;
    this.onChange(null);
  }
  public KeyPress(evt: any) {
    if (evt.keyCode == 13) {
      evt.stopPropagation();
    }
  }
  public InputKeyPress(evt: any) {

  }

}
